export const formatNumber = (number: string | number): string => {
  const sanitizedNumber = typeof number === 'string' ? parseInt(number) : number;

  const mapToSpelling: { [key: number]: string } = {
    0: 'zero',
    1: 'one',
    2: 'two',
    3: 'three',
    4: 'four',
    5: 'five',
    6: 'six',
    7: 'seven',
    8: 'eight',
    9: 'nine',
  };

  if (sanitizedNumber >= 0 && sanitizedNumber < 10) {
    return mapToSpelling[sanitizedNumber];
  }

  return sanitizedNumber.toString();
};
